import { useMutation } from 'react-query';
import qs from 'qs';
import blobUtils from 'src/utils/blob';
import api from 'src/services/api';
import appUtils from 'src/components/appUtils';

export const exportGoalsQuery = () => useMutation(async ({ filename, filters }) => {
  const loggedUser = appUtils.getLoggedUser();
  const { companyid } = loggedUser;
  const params = qs.stringify(
    {
      ...filters,
      companyid
    },
    { skipNulls: true }
  );
  const blob = await api.getXLS(`/goals/export?${params}`);
  blobUtils.triggerBlobDownload(blob, filename);
});

export const downloadGoalsSampleQuery = () => useMutation(async ({ filename }) => {
  const blob = await api.getXLS('/goals/template');
  blobUtils.triggerBlobDownload(blob, filename);
});

export const uploadGoalsQuery = () => useMutation((formData) => api.postForm('/goals/upload', formData));

export default {};
